import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Select } from 'antd';

interface ImpersonationTabProps {
  userOptions: { value: string; label: string }[];
  onStart: (targetUsername: string, reason?: string) => Promise<any>;
}

const ImpersonationTab: React.FC<ImpersonationTabProps> = ({ userOptions, onStart }) => {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState<string | undefined>(undefined);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleStart = () => {
    if (!selectedUser) return;
    setLoading(true);
    onStart(selectedUser, reason || undefined).finally(() => setLoading(false));
  };

  return (
    <div className="d-flex flex-column gap-3" style={{ maxWidth: 480 }}>
      <p className="text-muted">
        {t(
          'Avvia una sessione di impersonazione verso l\'utente selezionato. Il token generato avrà i ruoli reali del target; potrai interromperla in qualsiasi momento dal banner che apparirà in cima alla pagina.',
        )}
      </p>

      <div className="form-group">
        <label className="d-block">{t('Utente')}</label>
        <Select
          className="w-100"
          showSearch
          allowClear
          placeholder={t('Cerca utente per nome o email...')}
          filterOption={(input, option) =>
            (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
          }
          value={selectedUser}
          onChange={(v) => setSelectedUser(v)}
          options={userOptions}
        />
      </div>

      <div className="form-group">
        <label className="d-block">{t('Motivo')}</label>
        <Input.TextArea
          placeholder={t('Motivo (opzionale)')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
        />
      </div>

      <div>
        <Button type="primary" disabled={!selectedUser || loading} loading={loading} onClick={handleStart}>
          {t('Avvia impersonazione')}
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationTab;
